import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../translation/namespace';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { Form, Input, NumberParam, Row, SonForm, SubmitButton, useForm } from '../../../_lib/Form2';

export type PageTypeValidityPeriodEditViewProps = {
  form: SonForm<NumberParam<'pageTypeValidityPeriodDays'>>;
};

export function PageTypeValidityPeriodEditView({ form }: PageTypeValidityPeriodEditViewProps) {
  const { t } = useTranslation(Namespace.PageTypeValidityPeriod);
  const { refresh } = useRefreshBlock();

  const onSuccess = () => {
    setTimeout(() => {
      refresh();
    }, 2000);
  };

  const { formProps, params, fetchState } = useForm({ form, onSuccess, activateLeavingGuard: true });
  const pageTypeValidityPeriodDays = params.getByName('pageTypeValidityPeriodDays');
  return (
    <Form id="pagetype-validity-form" {...formProps}>
      <Row>
        <Input
          label={t('form.validityTitle')}
          helpText={t('form.validityHelpText')}
          param={pageTypeValidityPeriodDays}
        />
      </Row>
      <SubmitButton
        buttonLabel={t(`form.submitButton`)}
        messageSuccess={t('Form:status.success')}
        messageSending={t('Form:status.sending')}
        messageFail={t('Form:status.fail')}
        fetchState={fetchState}
        active={fetchState.type !== 'loading' && fetchState.type !== 'success'}
      />
    </Form>
  );
}
